import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_cart_4: FaireProductEntity = {
  token: "atc_fs_cart_4",
  type: "product",
  name: "Clean Girl Solid Perfume",
  brandName: "West Clay Company",
  brandToken: "west-clay-company",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4a6c774f57af8f42fd41a0e4eba5dcf3d1f60cdc2b777557da6148ddfc5021fe.webp",
  priceDollars: 22,
  msrpDollars: 44,
  description: "ATC cart product seed",
  tags: ["beauty", "atc", "cart"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
